import { CURRENCY_SYMBOLS, ECurrency } from './interfaces.js';
export const EMarketingBannerModuleType = {
    VacationPackages: 'VacationPackages',
    DynamicPackages: 'DynamicPackages',
};
export const EMarketingBannerDayFilter = {
    AllDays: 'AllDays',
    WeekendsOnly: 'WeekendsOnly',
    SpecificDays: 'SpecificDays',
};
export const EMarketingBannerBaggage = {
    Trolley: 'Trolley',
    CheckedBaggage: 'CheckedBaggage',
    TrolleyAndChecked: 'TrolleyAndChecked',
    NoBaggage: 'NoBaggage',
};
export const EMarketingBannerDestinationStatus = {
    Active: 'Active',
    Hidden: 'Hidden',
    NoDeals: 'NoDeals',
};
export const EMarketingBannerCardStatus = {
    Active: 'Active',
    Inactive: 'Inactive',
    Hidden: 'Hidden',
    Expired: 'Expired',
    NoDeals: 'NoDeals',
};
export const MARKETING_BANNERS_CATALOG_FILE = 'marketing-banners';
export const MARKETING_BANNER_PRICE_PREFIX = 'החל מ-';
export const MARKETING_BANNER_DEFAULT_CURRENCY = ECurrency.USD;
export const getMarketingBannerCurrencySymbol = (currency) => {
    const resolved = currency ?? MARKETING_BANNER_DEFAULT_CURRENCY;
    return CURRENCY_SYMBOLS[resolved] ?? CURRENCY_SYMBOLS[MARKETING_BANNER_DEFAULT_CURRENCY];
};
export const formatMarketingBannerPriceCtaLabel = (minPrice, currency) => {
    return `${MARKETING_BANNER_PRICE_PREFIX}${getMarketingBannerCurrencySymbol(currency)}${minPrice.toLocaleString('en-US')}`;
};
const RICH_TEXT_TAG_PATTERN = /<[^<>]*>/g;
const RICH_TEXT_NBSP_PATTERN = /&nbsp;|\u00A0/g;
const RICH_TEXT_MEDIA_PATTERN = /<(?:img|video|iframe)\b/i;
export const hasMarketingBannerRichTextContent = (html) => {
    if (!html) {
        return false;
    }
    if (RICH_TEXT_MEDIA_PATTERN.test(html)) {
        return true;
    }
    return html.replace(RICH_TEXT_TAG_PATTERN, '').replace(RICH_TEXT_NBSP_PATTERN, ' ').trim().length > 0;
};
export const MARKETING_BANNERS_CATALOG_PATH = `/dynamic/client/${MARKETING_BANNERS_CATALOG_FILE}.json`;
//# sourceMappingURL=marketing-banners.js.map